import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-bsbadge',
	templateUrl:'./BSBadgePage.html',
	styles: [],
	styleUrls:['./BSBadgePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSBadgePage
{
	mdContent_62 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.badge.BSBadge;
\`\`\``;
	mdContent_63 = `\`\`\`java
new BSBadge<>()
\`\`\``;
	mdContent_64 = `\`\`\`java
new BSBadgePrimary<>()
\`\`\``;
	mdContent_65 = `\`\`\`java
var badge = new BSBadgePrimary<>();
badge.setText("New");
\`\`\``;
}
